import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { quoteAccommodationFormDefault } from "@factory/form/form.default";
import { QuoteAccommodationFormRule, QuoteAccommodationFormSchema } from "@factory/form/form.rule";
import { useQyCreateQuoteAccommodation } from "@factory/query/quote-accommodation.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewQuoteAccommodation() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateQuoteAccommodation } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New QuoteAccommodation is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addQuoteAccommodation, isLoading: isCreating } =
    useQyCreateQuoteAccommodation(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<QuoteAccommodationFormSchema>({
    defaultValues: quoteAccommodationFormDefault,
    resolver: zodResolver(QuoteAccommodationFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: QuoteAccommodationFormSchema) => {
    const formData = mapCreateQuoteAccommodation(form);
    addQuoteAccommodation(formData);
  };
  const handleValidateError = (err: FieldErrors<QuoteAccommodationFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
